import { Component } from '@angular/core';

@Component({
  selector: 'app-toolbar-shell',
  imports: [],
  templateUrl: './toolbar-shell.component.html',
  styleUrl: './toolbar-shell.component.scss',
})
export class ToolbarShellComponent {}
